import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/SK';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/SK';
import { cardImage } from '../card-image/SK';
import { cardInsurance } from '../card-insurance/SK';
import { limitsChange } from '../card-limits-change/SK';
import { cardLimitsFocusPage } from '../card-limits-focus-page/SK';
import { limits } from '../card-limits/combined-limits/SK';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/SK';
import { permanentLimits } from '../card-limits/permanent-limits/SK';
import { temporaryLimits } from '../card-limits/temporary-limits/SK';
import { cardLockAndReplace } from '../card-lock-and-replace/SK';
import { cardLock } from '../card-lock/SK';
import { prepaidCardInfo } from '../card-prepaid-info/SK';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/SK';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/SK';
import { cardCancellation } from '../card-services/card-cancellation/SK';
import { cardDelivery } from '../card-services/card-delivery/SK';
import { changeCardDesign } from '../card-services/card-design-change/SK';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/SK';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/SK';
import { cardMigrationExternal } from '../card-services/card-migration-external/SK';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/SK';
import { cardReissue } from '../card-services/card-reissue/SK';
import { orderReplacementCard } from '../card-services/card-replacement/SK';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/SK';
import { changeCardDelivery } from '../card-services/delivery-management-v2/SK';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/SK';
import { changePinDelivery } from '../card-services/pin-delivery-change/SK';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/SK';
import { pinDelivery } from '../card-services/pin-delivery/SK';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/SK';
import { reprintPin } from '../card-services/reprint-pin/SK';
import { cardTracking } from '../card-tracking/SK';
import { cardUnlock } from '../card-unlock/SK';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/SK';
import { cardLimitInfo } from '../cards-bank/card-limit-info/SK';
import { cardReplacement } from '../cards-bank/card-replacement/SK';
import { geoControl } from '../cards-bank/geo-control/SK';
import { linkedAccounts } from '../cards-bank/linked-accounts/SK';
import { microCardActivation } from '../cards-bank/micro-card-activation/SK';
import { microSticker } from '../cards-bank/micro-sticker/SK';
import { cardServices } from '../cards-credit/additional-services/SK';
import { cardFees } from '../cards-credit/card-fees/SK';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/SK';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/SK';
import { creditCardMeter } from '../cards-credit/card-meter/SK';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/SK';
import { creditCardPayUp } from '../cards-credit/pay-up/SK';
import { autoRepayment } from '../cards-credit/repayment/SK';
import { creditCardStatements } from '../cards-credit/statements/SK';
import { contactlessPayments } from '../contactless-payments/SK';
import { expirationTime } from '../expiration-time/SK';
import { installmentsActivation } from '../installments-activation/SK';
import { installments } from '../installments/SK';
import { temporaryDeactivation } from '../temporary-deactivation/SK';
import { topUp } from '../top-up/SK';
import { upcomingInstallments } from '../upcoming-installments/SK';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: true,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: true,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: true,
    },
    nativeCardOrder: {
        enabled: false,
    },
    nativeCardReplacement: {
        enabled: false,
    },
};
